import { AnswerDetails, LinksType, LocationProperties, TemplateContent, UuidableName } from 'utils/api/types';

import { UserNameResponse } from 'utils/api/modules/user/user.types';

import { MultipleAnswerQuestionType, SectionType } from 'stores/TemplateDetails/types';

import { LinkedTaskType } from '../tasks/tasks.types';
import { LocationAddressResponse } from '../devices/devices.types';
import { EntitiesModulesUpdateKeys } from '../entities/entities.types';

export const InspectionEntity = 'inspection';

export interface InspectionTaskLinkType {
  isActive: boolean;
  question: string;
  questionId: string;
  position: number;
}

export interface InspectionTaskLinkToUpdateType {
  entity: string;
  instance: string;
  extraData?: { questionId: string } | {};
}

export interface InspectionQuestionsSearchResponse {
  id: string;
  position: number;
  description: string;
}

export interface InspectionSearchResponse extends UuidableName {
  reporter: UuidableName;
  submitted: string | null;
}

// oxlint-disable-next-line typescript/no-explicit-any
export const isMultipleAnswerQuestionType = (obj: any): obj is MultipleAnswerQuestionType =>
  obj.workflowsType === 'multi' && obj.items.enum !== undefined && obj.items.enum.length > 0;

export interface TemplateListResponse extends UuidableName {
  isActive: boolean;
  creator: UserNameResponse;
  lastUpdate: string;
}

export interface TemplateDetailsResponse extends TemplateListResponse {
  content: TemplateContent;
}

export interface AnswerStats {
  comments: number;
  tasks: number;
  files: number;
}

export interface FormTemplateContent {
  order: string[];
  properties: { [key: string]: SectionType };
}

export interface TemplateNameContent {
  name: string;
  content: FormTemplateContent;
}

export type TemplateCreateType = {
  templateVersion: string;
  name: string;
  site?: string;
  asset?: string;
  event?: string;
  document?: string;
  contact?: string;
};

export interface FormsDetailsResponse {
  uuid: string;
  name: string;
  reporter: UserNameResponse;
  submitted: string | null;
  isActive: boolean | null;
  location: LocationAddressResponse | null;
  linkedTasks: LinkedTaskType;
  details: AnswerDetails;
  stats: { [key: string]: AnswerStats };
  template: TemplateNameContent;
  links: Array<LinksType>;
}

export enum FormStatus {
  InProgress = 'in_progress',
  Submitted = 'submitted',
}

export type SelectedAnswerType = string | string[] | LocationProperties | boolean | null | undefined;

interface UpdatableFormData {
  details: { [key: string]: SelectedAnswerType };
  submitted: string;
  reporter: string;
  location: { address: string | null };
  name: string;
  status: FormStatus;
}

export type FormUpdateData = Partial<UpdatableFormData> & Partial<EntitiesModulesUpdateKeys>;
